import { render, staticRenderFns } from "./ListData.vue?vue&type=template&id=fc617fd6&scoped=true&"
import script from "./ListData.vue?vue&type=script&lang=js&"
export * from "./ListData.vue?vue&type=script&lang=js&"
import style0 from "./ListData.vue?vue&type=style&index=0&id=fc617fd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc617fd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VChip,VChipGroup,VListItemContent,VListItemTitle})
